import {ISidenavService} from './sidenav.types';

export class SidenavService implements ISidenavService {
  static $inject = ['$mdSidenav'];

  constructor(private $mdSidenav:ng.material.ISidenavService) {
  }

  toggleLeftSidenav = () => {
    this.$mdSidenav('left').toggle();
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/sidenav/sidenav.service.ts
 **/